var map = {
	"./assignment.json": 50447,
	"./assignmentSettings.json": 38150,
	"./auth.json": 23552,
	"./chat.json": 38260,
	"./common.json": 47067,
	"./course.json": 615,
	"./quiz.json": 86655,
	"./videoGrading.json": 38747,
	"locales/es/assignment.json": 50447,
	"locales/es/assignmentSettings.json": 38150,
	"locales/es/auth.json": 23552,
	"locales/es/chat.json": 38260,
	"locales/es/common.json": 47067,
	"locales/es/course.json": 615,
	"locales/es/quiz.json": 86655,
	"locales/es/videoGrading.json": 38747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20743;